import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../../data.service';
import { SettingAuthSatuSehatApiService } from '../../../api/go-service/settings-service/setting-auth-satusehat.api.service';

@Injectable({
  providedIn: 'root',
})
export class SettingAuthSatuSehatDataService implements DataService<{ dateMake: string }> {
  constructor(private settingFormCpptApiService: SettingAuthSatuSehatApiService) {}

  public getAll(): Observable<{ dateMake: string }> {
    return this.settingFormCpptApiService.getAll();
  }
}
